import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../../../design/inputs/select/Select';
import { S_FieldLabel } from '../../../../design/labels/fieldLabel/S_FIeldLabel';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { UserRole } from '../../user/user.store';

interface IChangeUserRoleModalProps {
  show: boolean;
  selectedRole: UserRole;
  onChange: (role: UserRole) => void;
  onClose: () => void;
  onSave: () => Promise<void>;
}

export const ChangeUserRoleModal = observer((props: IChangeUserRoleModalProps): ReactElement => {
  const { t } = useTranslator();

  const handleSelectedRoleChange = (value: UserRole | null): void => {
    props.onChange(value ?? UserRole.User);
  };

  const options = [
    { value: UserRole.Administrator, label: t('administrator') },
    { value: UserRole.User, label: t('user') },
  ];

  return (
    <S_Modal
      isOpen={props.show}
      toggle={props.onClose}
      headerText={t('change_user_role')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onClose}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={() => {
              void props.onSave();
            }}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      <div>
        <S_FieldLabel>{t('select_role')}</S_FieldLabel>
        <Select
          id='user-change-role-dropdown'
          value={options.find((x) => x.value === props.selectedRole)}
          onChange={(_, v) => {
            handleSelectedRoleChange(v.value);
          }}
          options={options}
        />
      </div>
    </S_Modal>
  );
});
